module.exports = __webpack_public_path__ + "static/media/school-stuffs.8472e5fc.jpg";